'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, e) {
    if (null == t) return {};
    var r, o, n = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        for(o = 0; o < i.length; o++)r = i[o], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
    }
    return n;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var r, o, n = {}, i = Object.keys(t);
    for(o = 0; o < i.length; o++)r = i[o], e.indexOf(r) >= 0 || (n[r] = t[r]);
    return n;
}
const LeftHandNavigation = renderWithRef('LeftHandNavigation', null, (r, o)=>{
    let { children: n, skin: i = 'standard' } = r, a = _object_without_properties(r, [
        "children",
        "skin"
    ]), s = new Set([
        'swan-lhn'
    ]);
    return i && 'standard' !== i && s.add(`swan-lhn-skin-${i}`), jsx(RenderComp, {
        root: "nav",
        forwardedRef: o,
        classNames: s,
        props: a,
        children: n
    });
});

export { LeftHandNavigation };
